<div class="sorter__wrapper" #sorterWrapper>
  <div>
    <div class="sorter__header-wrapper">
      <div class="sorter__search-filter">
        <app-consultant-search-field
          [scope]="searchScope"
          [term]="searchValueString"
          (scopeChange)="onSearchScopeChange($event)"
          (termInput)="onSearchTermInput($event)"
        ></app-consultant-search-field>
        <button
          mat-mini-fab
          (click)="onFilter()"
          [ngClass]="{ sorter__filter: amount != 0 }"
          [attr.aria-label]="
            (amount
              ? ('userlistSorter.filterActive' | translate: { count: amount })
              : ('userlistSorter.filter' | translate)) +
            (profilerLanguage
              ? ', ' +
                ('profilerLanguage.short' | translate) +
                ' ' +
                (profilerLanguageLabelKey | translate)
              : '')
          "
        >
          <mat-icon>filter_alt</mat-icon>
          @if (amount != 0) {
            - {{ amount }}
          }
          @if (profilerLanguage) {
            <span class="sorter__profiler-language">
              &middot; {{ 'profilerLanguage.short' | translate }}
              <app-profiler-language-flag
                [langKey]="profilerLanguage"
                [showTooltip]="false"
              ></app-profiler-language-flag>
              {{ profilerLanguageLabelKey | translate }}
            </span>
          }
        </button>

        <button mat-mini-fab (click)="toggleSelect()">
          <mat-icon>sorter</mat-icon>
        </button>

        <div
          class="sorter__company-chips"
          role="group"
          [attr.aria-label]="'userlistSorter.companyFilter' | translate"
        >
          <button
            type="button"
            class="sorter__fchip"
            [ngClass]="{ 'sorter__fchip--on': selectedCompany === 'ALL' }"
            (click)="onCompanyFilter('ALL')"
          >
            {{ 'userlistSorter.allCompanies' | translate }}
          </button>
          @for (company of companies(); track company.id) {
            <button
              type="button"
              class="sorter__fchip"
              [ngClass]="{
                'sorter__fchip--on':
                  selectedCompany === company.abbreviation && !company.color,
              }"
              [style]="
                chipStyle(
                  company.color,
                  selectedCompany === company.abbreviation
                )
              "
              [matTooltip]="company.name"
              (click)="onCompanyFilter(company.abbreviation)"
            >
              {{ company.abbreviation }}
            </button>
          }
        </div>

        <button
          type="button"
          class="sorter__fchip"
          [ngClass]="{ 'sorter__fchip--on-bewerber': applicantOnly }"
          [attr.aria-pressed]="applicantOnly"
          [attr.aria-label]="'userlistSorter.applicantFilter' | translate"
          (click)="onApplicantFilter()"
        >
          {{ 'userlistSorter.applicants' | translate }}
        </button>

        <button
          type="button"
          class="sorter__fchip"
          [ngClass]="{ 'sorter__fchip--on-freelancer': freelancerOnly }"
          [attr.aria-pressed]="freelancerOnly"
          [attr.aria-label]="'userlistSorter.freelancerFilter' | translate"
          (click)="onFreelancerFilter()"
        >
          {{ 'userlistSorter.freelancers' | translate }}
        </button>

        @if (showSelect) {
          <mat-form-field class="sorter__sorter-container">
            <mat-select
              #sortSelect
              [placeholder]="'userlistSorter.selectSorting' | translate"
              (selectionChange)="onSort($event)"
              [(value)]="sortValue"
            >
              <mat-option value="availableAsc">{{
                'userlistSorter.availabilityAsc' | translate
              }}</mat-option>
              <mat-option value="availableDesc">{{
                'userlistSorter.availabilityDesc' | translate
              }}</mat-option>
              <mat-option value="nameAsc">{{
                'userlistSorter.nameAsc' | translate
              }}</mat-option>
              <mat-option value="nameDesc">{{
                'userlistSorter.nameDesc' | translate
              }}</mat-option>
              <mat-option value="consultantAsc">{{
                'userlistSorter.consultantSinceAsc' | translate
              }}</mat-option>
              <mat-option value="consultantDesc">{{
                'userlistSorter.consultantSinceDesc' | translate
              }}</mat-option>
              <mat-option value="profilerLanguage">{{
                'userlistSorter.profilerLanguage' | translate
              }}</mat-option>
              <mat-option value="openBadgesDesc">{{
                'userlistSorter.openBadgesDesc' | translate
              }}</mat-option>
            </mat-select>
          </mat-form-field>
        }
      </div>
      <div class="sorter__button-container">
        <mat-slide-toggle (change)="onArchive($event)">{{
          'userlistSorter.archive' | translate
        }}</mat-slide-toggle>
        <mat-slide-toggle
          class="sorter__list-toggle"
          (change)="onListView($event)"
          >{{ 'userlistSorter.listView' | translate }}
        </mat-slide-toggle>
      </div>
    </div>
  </div>

  <app-completeness-filter
    [selected]="completenessLevels"
    [counts]="completenessCounts"
    (selectedChange)="completenessLevelsChange.emit($event)"
  ></app-completeness-filter>
</div>
